export default __webpack_public_path__ + "static/media/mobile-cover.9ff9b186.png";